import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import { processNewMathInElem } from '@instructure/quiz-rce';
export var DropTargetContainer = /*#__PURE__*/function (_Component) {
  function DropTargetContainer() {
    var _this;
    _classCallCheck(this, DropTargetContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DropTargetContainer, [].concat(args));
    _defineProperty(_this, "containerRef", null);
    _defineProperty(_this, "handleContainerRef", function (node) {
      _this.containerRef = node;
    });
    _defineProperty(_this, "componentDidUpdate", function (prevProps) {
      processNewMathInElem(_this.containerRef);
    });
    return _this;
  }
  _inherits(DropTargetContainer, _Component);
  return _createClass(DropTargetContainer, [{
    key: "render",
    value: function render() {
      return this.props.connectDropTarget(/*#__PURE__*/React.createElement("div", {
        className: this.props.className,
        ref: this.handleContainerRef
      }, this.props.children));
    }
  }]);
}(Component);

// =============
// DRAG AND DROP
// =============
_defineProperty(DropTargetContainer, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  className: PropTypes.string,
  connectDropTarget: PropTypes.func.isRequired,
  // injected by React DnD
  onDrop: PropTypes.func.isRequired
});
_defineProperty(DropTargetContainer, "defaultProps", {
  className: void 0
});
export var dropTarget = {
  drop: function drop(props, monitor, component) {
    var droppedItem = monitor.getItem();
    props.onDrop(droppedItem);
  }
};
function collectDrop(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}
var DropTargetWrapper = DropTarget('dnd', dropTarget, collectDrop)(DropTargetContainer);
export default DropTargetWrapper;